import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Target, Users } from 'lucide-react';

function Counter({ from, to, duration = 2 }) {
  const [count, setCount] = useState(from);

  useEffect(() => {
    let startTime;
    const animateCount = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / (duration * 1000), 1);
      
      // Easing function (easeOutExpo)
      const easeProgress = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);
      setCount(Math.floor(from + (to - from) * easeProgress));

      if (percentage < 1) {
        requestAnimationFrame(animateCount);
      }
    };
    requestAnimationFrame(animateCount);
  }, [from, to, duration]);

  return <span>{count.toLocaleString('fr-FR')}</span>;
}

export default function LiveStats() {
  const stats = [
    { label: 'Menaces bloquées', value: 47, icon: Target, color: 'text-red-500', bg: 'bg-red-100' },
    { label: 'Sites sécurisés', value: 132, icon: ShieldCheck, color: 'text-emerald-500', bg: 'bg-emerald-100' },
    { label: 'Utilisateurs', value: 23, icon: Users, color: 'text-blue-500', bg: 'bg-blue-100' },
  ];

  return (
    <div className="mx-4 mt-8">
      <p className="font-semibold text-text-primary text-sm mb-3">Impact en temps réel</p>
      <div className="grid grid-cols-3 gap-3">
        {stats.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.15, duration: 0.5, type: 'spring' }}
            whileHover={{ scale: 1.05, translateY: -5 }}
            className="bg-white rounded-[14px] p-3 text-center shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-1.5"
          >
            <div className={`w-8 h-8 rounded-full ${stat.bg} ${stat.color} flex items-center justify-center mb-1`}>
              <stat.icon className="w-4 h-4" />
            </div>
            <div className="font-extrabold text-brand-navy text-lg leading-none">
              <Counter from={0} to={stat.value} />
            </div>
            <div className="text-[10px] text-text-muted font-medium uppercase tracking-wider">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
